module.exports = __webpack_public_path__ + "static/img/jieshao4.4110e42a.png";